import styled, { keyframes } from "styled-components";
import { Skeleton } from "../../components/skeleton/Skeleton.styles";

const pinPreviewIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(6px) scale(0.96);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1.04);
  }
`;

const pinMenuIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(-8px) scale(0.97);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
`;

export const ProfileHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  max-width: 600px;
  padding-top: 16px;
  align-self: center;
  width: 100%;
  margin: 0 auto;
  @media (max-width: 768px) {
    margin: unset;
    align-self: unset;
  }
`;

export const ProfileHeaderRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
`;

export const ProfileHeaderColumn = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 7px;
  min-height: 120px;
  @media (max-width: 768px) {
    min-height: 80px;
  }
`;

export const PaginationWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  margin-bottom: 1.6rem;
`;
export const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 60px 20px;
  text-align: center;
  flex: 1;

  h3 {
    font-size: 24px;
    margin-bottom: 12px;
    font-family: Figtree;
  }

  p {
    font-size: 16px;
    line-height: 1.5;
    max-width: 400px;
    font-family: Figtree;
    opacity: 0.6;
    margin-bottom: 24px;
  }
`;

export const Button = styled.button`
  display: flex;
  width: ${(props) => (props.$width ? "100%" : "180px")};
  height: 40px;
  padding: 12px 44px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 100px;
  background: #fff;
  border: none;
  outline: none;
  white-space: nowrap;

  color: #081120;
  font-family: Figtree;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: -0.21px;
  cursor: pointer;

  transition: all 0.3s ease-in-out;

  &:hover {
    transform: scale(1.025);
  }

  &:active {
    transform: scale(0.975);
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
`;

export const NameContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 6px;
`;

export const Name = styled.span`
  color: #fff;
  font-family: Figtree;
  font-size: 18px;
  font-weight: 600;
  letter-spacing: 0.09px;
`;

export const ContentContainer = styled.div`
  flex: 1;
  width: 100%;
  display: flex;
  /* padding-inline: 16px; */
`;

export const PlanBadge = styled.div`
  display: flex;
  height: 18px;
  padding: 4px 6px;
  justify-content: center;
  align-items: center;
  gap: 2px;
  border-radius: 24px;

  color: #fff;
  text-align: center;
  font-family: "Google Sans Flex";
  font-size: 10px;
  font-weight: 900;
  letter-spacing: -0.55px;
  text-transform: uppercase;

  border: ${(props) => props.$border || "none"};
  background: ${(props) => props.$gradient || "transparent"};

  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: -9px;
`;
export const XpContainer = styled.div`
  border-radius: 100px;
  display: flex;
  height: 22px;
  padding: 4px 6px;
  justify-content: center;
  align-items: center;
  gap: 2px;
  border: 0.5px solid #73a2e1;
  background: radial-gradient(
    110.8% 48.74% at 43.66% 0%,
    #87b6f6 0%,
    #043a71 100%
  );

  text-transform: uppercase;
  color: #fff;
  user-select: none;
  font-family: "Google Sans Flex";
  font-size: 12px;
  font-weight: 800;
  letter-spacing: -0.66px;
`;
export const VipBadge = styled.div`
  display: flex;
  height: 22px;
  padding: 4px 6px;
  justify-content: center;
  align-items: center;
  gap: 2px;

  border-radius: 20px;
  border: 0.5px solid #760ea2;
  background: linear-gradient(270deg, #a341e4 0%, #24073d 100%);

  color: #fff;
  font-family: "Google Sans Flex";
  font-size: 12px;
  font-weight: 900;
  letter-spacing: -0.66px;
  text-transform: uppercase;
  user-select: none;
`;

export const BadgesContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
`;

export const MedalBadge = styled.div`
  display: flex;
  height: 22px;
  padding: 0 8px;
  justify-content: center;
  overflow: hidden;
  align-items: flex-start;
  gap: 2px;
  border-radius: 100px;

  border: ${(p) => {
    if (p.$rank === 1) return "0.5px solid #EEA015";
    if (p.$rank === 2) return "0.5px solid #BCBCBC";
    if (p.$rank === 3) return "0.5px solid #612501";
    if (p.$rank >= 4 && p.$rank <= 5) return "0.5px solid #FFD86B";
    if (p.$rank >= 6 && p.$rank <= 10) return "0.5px solid #BCBCBC";
    return "0.5px solid #345884";
  }};

  background: ${(p) => {
    if (p.$rank === 1)
      return "linear-gradient(213deg, #FFBD25 6.81%, #A85F00 52.91%, #C58300 93.19%)";
    if (p.$rank === 2)
      return "linear-gradient(41deg, #1C1C1C -5.1%, #464646 36.56%, #8E8E8E 92.26%)";
    if (p.$rank === 3)
      return "linear-gradient(213deg, #391501 6.81%, #632500 43.77%, #381500 93.19%)";
    if (p.$rank >= 4 && p.$rank <= 5)
      return "linear-gradient(213deg, #FFE066 6.81%, #E5B800 52.91%, #8C6500 93.19%)";
    if (p.$rank >= 6 && p.$rank <= 10)
      return "linear-gradient(41deg, #1C1C1C -5.1%, #464646 36.56%, #8E8E8E 92.26%)";
    return "#142743";
  }};
`;

export const MedalIcon = styled.img`
  width: 20px;
  height: 20px;
  object-fit: contain;
  pointer-events: none;
  user-select: none;
`;

export const Username = styled.span`
  color: #fff;
  font-family: Figtree;
  font-size: 17px;
  font-weight: 600;
  letter-spacing: 0.07px;
`;
export const MedalImg = styled.img`
  pointer-events: none;
  user-select: none;
  width: 13px;
  height: 13px;
`;

export const ProfilePhotoContainer = styled.div`
  position: relative;
  max-height: 120px;
  @media (max-width: 768px) {
    max-height: 76px;
  }
`;

export const ProfilePhoto = styled.img`
  display: flex;
  width: 120px;
  height: 120px;
  justify-content: center;
  align-items: center;
  aspect-ratio: 1/1;
  border-radius: 50%;

  border: ${(p) => p.$border};
  @media (max-width: 768px) {
    width: 76px;
    height: 76px;
  }
`;

export const StatsContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 24px;
`;

export const Stats = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 2px;

  color: #fff;
  font-family: Figtree;
  font-size: ${(p) => (p.$light ? "14px" : "15px")};
  font-weight: ${(p) => (p.$light ? "300" : "600")};
  opacity: ${(p) => (p.$light ? 0.5 : 1)};
  letter-spacing: 0.07px;

  cursor: ${(p) => (p.$click ? "pointer" : "default")};
`;

export const Description = styled.span`
  color: #fff;
  font-family: Figtree;
  font-size: 15px;
  font-weight: 400;
  letter-spacing: 0.065px;
  opacity: 0.8;
  @media (max-width: 768px) {
    display: none;
  }
`;

export const MobileDescription = styled.span`
  color: #fff;
  font-family: Figtree;
  font-size: 15px;
  font-weight: 400;
  letter-spacing: 0.065px;
  opacity: 0.8;
  display: none;
  @media (max-width: 768px) {
    display: flex;
  }
`;

export const Buttons = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
`;

export const FollowButton = styled.button`
  display: flex;
  height: 38px;
  padding: 11px 24px 11px 12px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  flex: 1 0 0;

  border-radius: 100px;
  border: ${(p) => (!p.$isFollowed ? "none" : "1px solid #345884")};
  background: ${(p) => (!p.$isFollowed ? "#fff" : "#142743")};
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.25);

  color: ${(p) => (p.$isFollowed ? "#fff" : "#060e1a")};
  font-family: Figtree;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0.07px;

  cursor: pointer;
  outline: none;
`;

export const FollowingButtonGroup = styled.div`
  position: relative;

  display: flex;
  flex: 1 0 0;
`;

export const FollowingMainButton = styled.button`
  display: flex;
  height: 38px;
  padding: 11px 14px 11px 56px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  flex: 1 0 0;

  border-radius: 100px 0 0 100px;
  border: 1px solid #345884;
  border-right: none;
  background: #142743;
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.25);

  color: #fff;
  font-family: Figtree;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0.07px;

  cursor: default;
  outline: none;
`;

export const FollowingArrowButton = styled.button`
  display: flex;
  width: 42px;
  height: 38px;
  justify-content: center;
  align-items: center;

  border-radius: 0 100px 100px 0;
  border: 1px solid #345884;
  border-left: none;
  background: #142743;
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.25);

  color: #fff;
  cursor: pointer;
  outline: none;

  svg {
    width: 12px;
    height: 12px;
    transform: ${(p) => (p.$open ? "rotate(180deg)" : "rotate(0deg)")};
    transition: transform 0.2s ease-in-out;
  }
`;

export const FollowingMenu = styled.div`
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  min-width: 148px;
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 8px;
  border-radius: 12px;
  border: 1px solid #213d64;
  background: #0e1c31;
  box-shadow: 0 12px 28px rgba(0, 0, 0, 0.35);
  z-index: 50;
`;

export const FollowingMenuItem = styled.button`
  display: flex;
  width: 100%;
  align-items: center;
  gap: 8px;
  padding: 10px 12px;
  border: none;
  border-radius: 8px;
  background: transparent;
  color: #fff;
  font-family: Figtree;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0.02px;
  cursor: pointer;
  outline: none;

  &:hover {
    background: #1a1a1d;
  }
`;

export const ShareButton = styled.button`
  display: flex;
  height: 38px;
  padding: 8px 16px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  flex: 1;

  border-radius: 100px;
  border: 1px solid #345884;
  background: #142743;
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.25);

  color: #fff;
  font-family: Figtree;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0.07px;

  cursor: default;
  outline: none;

  @media (max-width: 768px) {
    flex: unset;
  }
`;

export const EmptyProfile = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #fff;
  font-family: Figtree;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: -0.07px;
  flex: 1;
`;

export const Content = styled.div`
  display: flex;
  gap: 4px;
  flex: 1;
`;

export const Column = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const ProfilePhotoSkeleton = styled(Skeleton)`
  border-radius: 50%;
  width: 120px;
  height: 120px;
  @media (max-width: 768px) {
    width: 76px;
    height: 76px;
  }
`;

export const MobileTextSkeleton = styled(Skeleton)`
  width: ${(p) => p.$width || "120px"};
  height: ${(p) => p.$height || "14px"};
  border-radius: 6px;
  display: none;
  @media (max-width: 768px) {
    display: flex;
  }
`;

export const DesktopTextSkeleton = styled(Skeleton)`
  width: ${(p) => p.$width || "120px"};
  height: ${(p) => p.$height || "14px"};
  border-radius: 6px;
  display: flex;
  @media (max-width: 768px) {
    display: none;
  }
`;
export const TextSkeleton = styled(Skeleton)`
  width: ${(p) => p.$width || "120px"};
  height: ${(p) => p.$height || "14px"};
  border-radius: 6px;
`;

export const ButtonSkeleton = styled(Skeleton)`
  width: ${(p) => p.$width || "120px"};
  height: 38px;
  border-radius: 100px;
  flex: 1 0 0;
`;

export const EmptyText = styled.span`
  color: #fff;
  font-family: Figtree;
  text-align: center;
  font-size: ${(p) => (p.$light ? "14px" : "18px")};
  font-weight: ${(p) => (p.$light ? "400" : "600")};
  opacity: ${(p) => (p.$light ? 0.6 : 1)};
  margin-bottom: ${(p) => (p.$light ? "32px" : "0")};
  letter-spacing: 0.09px;
`;

export const ToastWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const CopyContainer = styled.div`
  padding: 12px;
  border-radius: 12px;
  border: 1px solid #213d64;
  background: #0e1c31;
  cursor: pointer;
  word-break: break-all;
  font-family: Figtree;
  font-size: 13px;
  color: #fff;

  transition: all 0.2s ease-in-out;
  &:hover {
    background: #1d1d1e;
  }
`;

export const PinPreviewBackdrop = styled.div`
  position: fixed;
  inset: 0;
  z-index: 3650;
  background: radial-gradient(
    circle at center,
    rgba(42, 80, 138, 0.16) 0%,
    rgba(8, 8, 10, 0.08) 32%,
    rgba(8, 8, 10, 0.42) 100%
  );
  backdrop-filter: blur(10px);
  pointer-events: none;
`;

export const PinPreviewCard = styled.div`
  position: fixed;
  top: ${(p) => `${p.$top}px`};
  left: ${(p) => `${p.$left}px`};
  z-index: 3700;
  width: ${(p) => `${p.$width}px`};
  height: ${(p) => `${p.$height}px`};
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border-radius: 24px;
  background: #0e1c31;
  box-shadow:
    0 26px 64px rgba(0, 0, 0, 0.5),
    0 10px 26px rgba(0, 0, 0, 0.28);
  transform-origin: center center;
  animation: ${pinPreviewIn} 0.18s ease-out forwards;
`;

export const PinPreviewImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  pointer-events: none;
  user-select: none;
  -webkit-user-select: none;
  -webkit-touch-callout: none;
  -webkit-user-drag: none;
`;

export const PinPreviewVideo = styled.video`
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  pointer-events: none;
  user-select: none;
  -webkit-user-select: none;
  -webkit-touch-callout: none;
  -webkit-user-drag: none;
`;

export const PinPreviewInfo = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  gap: 3px;
  padding: 18px 18px 16px;
  background: linear-gradient(
    180deg,
    rgba(7, 7, 9, 0) 0%,
    rgba(7, 7, 9, 0.74) 56%,
    rgba(7, 7, 9, 0.94) 100%
  );
`;

export const PinPreviewTitle = styled.span`
  color: #fff;
  font-family: Figtree;
  font-size: 17px;
  font-weight: 600;
  letter-spacing: -0.03px;
`;

export const PinPreviewSubtitle = styled.span`
  color: rgba(255, 255, 255, 0.62);
  font-family: Figtree;
  font-size: 13px;
  font-weight: 400;
  letter-spacing: 0.01px;
`;

export const PinActionMenu = styled.div`
  position: fixed;
  top: ${(p) => `${p.$top}px`};
  left: ${(p) => `${p.$left}px`};
  z-index: 3701;
  display: flex;
  min-width: ${(p) => `${p.$width}px`};
  flex-direction: column;
  padding: 8px;
  border-radius: 22px;
  border: 1px solid rgba(255, 255, 255, 0.04);
  background: rgba(18, 18, 20, 0.72);
  box-shadow:
    0 18px 36px rgba(0, 0, 0, 0.42),
    inset 0 1px 0 rgba(255, 255, 255, 0.05);
  backdrop-filter: blur(24px) saturate(1.35);
  -webkit-backdrop-filter: blur(24px) saturate(1.35);
  animation: ${pinMenuIn} 0.18s ease-out forwards;
`;

export const PinActionItem = styled.button`
  width: 100%;
  min-height: 52px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 12px 22px 12px 8px;
  border: none;
  border-radius: 16px;
  background: transparent;
  color: #fff;
  font-family: Figtree;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: -0.02px;
  cursor: pointer;
  outline: none;

  &:hover:not(:disabled) {
    background: rgba(255, 255, 255, 0.06);
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.7;
  }

  svg {
    width: 18px;
    height: 18px;
  }
`;
